import React from "react";

export default function ScreenHeader({
  title,
  description,
  timestamp,
  containerClassName = "",
  titleClassName = "",
  descriptionClassName = "",
  actionsClassName = "",
  timestampClassName = ""
}) {
  return (
    <header className={containerClassName}>
      <div>
        <h1 className={titleClassName}>{title}</h1>
        <div className={descriptionClassName}>{description}</div>
      </div>
      {timestamp && (
        <div className={actionsClassName}>
          <div className={timestampClassName}>Last updated: {timestamp}</div>
        </div>
      )}
    </header>
  );
}
